export default __webpack_public_path__ + "assets/png/d995a479c277356bb11f9a47ee76f0b7.png";